<template>
  <div>
    <v-card elevation="0" :loading="loading" :disabled="loading">
      <v-card-text>
        <v-form v-model="form_validate_status" ref="form">
          <v-card-title>{{
            $t("info_card.information_for_the_course")
          }}</v-card-title>
          <v-divider color="white"></v-divider>
          <br />

          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint()">
              <!-- จำนวนเทอมของ GPA -->
              <v-autocomplete
                v-model="Constraint_termOfGpa"
                v-bind:label="$t('info_card.number_of_GPA_term')"
                v-bind:item-text="(item) => item"
                v-bind:items="terms"
                v-bind:item-value="(item) => item"
                v-bind:rules="requiredRules"
                @input="checkbox = false"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(2)">
              <!-- GPA รวมทุกวิชา -->
              <GpaCard
                v-model="Constraint_allGpa"
                v-bind:textLabel="$t('info_card.all_gpa')"
                v-bind:textPlaceholder="$t('info_card.all_gpa')"
                @input="checkbox = false"
                :disabled="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(3)">
              <!-- GPA วิชาภาษาไทย-->
              <GpaCard
                v-model="Constraint_thaiGpa"
                v-bind:textLabel="$t('info_card.thai_gpa')"
                v-bind:textPlaceholder="$t('info_card.thai_gpa')"
                @input="checkbox = false"
              />
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(4)">
              <!-- หน่วยกิต วิชาภาษาไทย-->
              <CreditCard
                v-model="Constraint_thaiCredit"
                v-bind:textLabel="$t('info_card.thai_credit')"
                v-bind:textPlaceholder="$t('info_card.thai_credit')"
                @input="checkbox = false"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(5)">
              <!-- GPA วิชาคณิตศาสตร์ -->
              <GpaCard
                v-model="Constraint_mathGpa"
                v-bind:textLabel="$t('info_card.math_gpa')"
                v-bind:textPlaceholder="$t('info_card.math_gpa')"
                @input="checkbox = false"
              />
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(6)">
              <!-- หน่วยกิต วิชาคณิตศาสตร์ -->
              <CreditCard
                v-model="Constraint_mathCredit"
                v-bind:textLabel="$t('info_card.math_credit')"
                v-bind:textPlaceholder="$t('info_card.math_credit')"
                @input="checkbox = false"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(7)">
              <!-- GPA วิชาวิทยาศาสตร์-->
              <GpaCard
                v-model="Constraint_scienceGpa"
                v-bind:textLabel="$t('info_card.science_gpa')"
                v-bind:textPlaceholder="$t('info_card.science_gpa')"
                @input="checkbox = false"
              />
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(8)">
              <!-- หน่วยกิต วิชาวิทยาศาสตร์-->
              <CreditCard
                v-model="Constraint_scienceCredit"
                v-bind:textLabel="$t('info_card.science_credit')"
                v-bind:textPlaceholder="$t('info_card.science_credit')"
                @input="checkbox = false"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(9)">
              <!-- GPA วิชาฟิสิกส์-->
              <GpaCard
                v-model="Constraint_physicsGpa"
                v-bind:textLabel="$t('info_card.physics_gpa')"
                v-bind:textPlaceholder="$t('info_card.physics_gpa')"
                @input="checkbox = false"
              />
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(10)">
              <!-- หน่วยกิต วิชาฟิสิกส์-->
              <CreditCard
                v-model="Constraint_physicsCredit"
                v-bind:textLabel="$t('info_card.physics_credit')"
                v-bind:textPlaceholder="$t('info_card.physics_credit')"
                @input="checkbox = false"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(11)">
              <!-- GPA วิชาเคมี-->
              <GpaCard
                v-model="Constraint_chemistryGpa"
                v-bind:textLabel="$t('info_card.chemistry_gpa')"
                v-bind:textPlaceholder="$t('info_card.chemistry_gpa')"
                @input="checkbox = false"
              />
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(12)">
              <!-- หน่วยกิต วิชาเคมี-->
              <CreditCard
                v-model="Constraint_chemistryCredit"
                v-bind:textLabel="$t('info_card.chemistry_credit')"
                v-bind:textPlaceholder="$t('info_card.chemistry_credit')"
                @input="checkbox = false"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(13)">
              <!-- GPA วิชาชีววิทยา-->
              <GpaCard
                v-model="Constraint_bioGpa"
                v-bind:textLabel="$t('info_card.bio_gpa')"
                v-bind:textPlaceholder="$t('info_card.bio_gpa')"
                @input="checkbox = false"
              />
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(14)">
              <!-- หน่วยกิต วิชาชีววิทยา-->
              <CreditCard
                v-model="Constraint_bioCredit"
                v-bind:textLabel="$t('info_card.bio_credit')"
                v-bind:textPlaceholder="$t('info_card.bio_credit')"
                @input="checkbox = false"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(15)">
              <!-- GPA วิชาวิทยาศาสตร์ และ คณิตศาสตร์-->
              <GpaCard
                v-model="Constraint_scienceMathGpa"
                v-bind:textLabel="$t('info_card.science_math_gpa')"
                v-bind:textPlaceholder="$t('info_card.science_math_gpa')"
                @input="checkbox = false"
              />
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(16)">
              <!-- หน่วยกิต วิชาวิทยาศาสตร์ และ คณิตศาสตร์-->
              <CreditCard
                v-model="Constraint_scienceMathCredit"
                v-bind:textLabel="$t('info_card.science_math_credit')"
                v-bind:textPlaceholder="$t('info_card.science_math_credit')"
                @input="checkbox = false"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(17)">
              <!-- GPA วิชาภาษาอังกฤษ-->
              <GpaCard
                v-model="Constraint_englishGpa"
                v-bind:textLabel="$t('info_card.english_gpa')"
                v-bind:textPlaceholder="$t('info_card.english_gpa')"
                @input="checkbox = false"
              />
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(18)">
              <!-- หน่วยกิต วิชาภาษาอังกฤษ-->
              <CreditCard
                v-model="Constraint_englishCredit"
                v-bind:textLabel="$t('info_card.english_credit')"
                v-bind:textPlaceholder="$t('info_card.english_credit')"
                @input="checkbox = false"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(20)">
              <!-- GPA วิชาภาษาต่างประเทศ-->
              <GpaCard
                v-model="Constraint_foreignGpa"
                v-bind:textLabel="$t('info_card.foreign_gpa')"
                v-bind:textPlaceholder="$t('info_card.foreign_gpa')"
                @input="checkbox = false"
              />
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(21)">
              <!-- หน่วยกิต วิชาภาษาต่างประเทศ-->
              <CreditCard
                v-model="Constraint_foreignCredit"
                v-bind:textLabel="$t('info_card.foreign_credit')"
                v-bind:textPlaceholder="$t('info_card.foreign_credit')"
                @input="checkbox = false"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" v-if="use_constarint(22)">
              <!-- ชื่อมาตรฐานความรู้ภาษาอังกฤษ -->
              <v-autocomplete
                v-model="Constraint_engExamName"
                v-bind:label="$t('info_card.english_exam')"
                v-bind:item-text="(item) => objectTranslator(item, 'name')"
                v-bind:items="englishs"
                v-bind:item-value="(item) => item.diplomaType_value"
                v-bind:rules="requiredRules"
                @input="checkbox = false"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(23)">
              <!-- คะแนนสอบมาตรฐานความรู้ภาษาอังกฤษ -->
              <v-text-field
                v-model="Constraint_engExamScore"
                v-bind:label="$t('info_card.score')"
                v-bind:placeholder="$t('info_card.score')"
                v-bind:rules="requiredRules"
                @input="checkbox = false"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" v-if="use_constarint(23)">
              <!-- คะแนนสอบมาตรฐานความรู้ภาษาอังกฤษ (คำแนะนำ) -->
              <span>{{ $t("info_card.english_exam_hint") }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              sm="12"
              v-if="use_constarint(23)"
              class="d-flex justify-center"
            >
              <span style="font-size: 18px;"
                ><span style="color:#FA8072"> ** </span>
                หากผู้สมัครยังไม่มีผลสอบภาษาอังกฤษ และสนใจสมัครสอบ
                <b>KMITL-TEP</b>
                สามารถดูรายละเอียดได้
                <v-btn class="ml-1" style="font-size: 18px;">
                  <a
                    href="https://la.kmitl.ac.th/article/kmitl-tep"
                    target="blank"
                    style="text-decoration: none;"
                  >
                    {{ $t("info_card.here") }}</a
                  >
                </v-btn>
              </span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12">
              <v-checkbox v-model="checkbox" v-bind:rules="requiredRules">
                <template v-slot:label>
                  <div>
                    {{ $t("info_card.checkbox_1") }}
                    <template>
                      <span class="text1">
                        {{ $t("info_card.checkbox_2") }}
                      </span>
                    </template>
                    {{ $t("info_card.checkbox_3") }}
                    <template>
                      <span class="text2">
                        {{ $t("info_card.checkbox_4") }}
                      </span>
                    </template>
                    {{ $t("info_card.checkbox_5") }}
                    <v-btn
                      outlined
                      rounded
                      small
                      to="/undergraduate/announcement"
                    >
                      {{ $t("info_card.announcement") }}
                    </v-btn>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-form>
        <div class="constraints_error_box" v-if="!all_clear">
          <span style="font-size: 18px;"
            >เงื่อนไขที่ยังไม่ครบถ้วนถูกต้องในการบันทึกครั้งก่อน
            หากแก้ไขแล้วกรุณากดบันทึกก่อน</span
          >
          <span v-for="item in constaints" :key="item.CONSTRAINT_ID">
            <div v-if="item.required && !item.passed">
              {{ get_constaints_error_text(item) }}
            </div>
          </span>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn block elevation="0" color="success" @click="validate()">{{
          $t("menu.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2" elevation="0" :loading="loading" :disabled="loading">
      <v-card-text>
        <v-card-title>{{ $t("info_card.history_title") }}</v-card-title>
        <v-simple-table dense class="mt-2">
          <template v-slot:default>
            <thead>
              <tr class="grey white--text">
                <th class="text-center">
                  {{ $t("info_card.history_date") }}
                </th>
                <th class="text-center">
                  {{ $t("info_card.history_type") }}
                </th>
                <th class="text-center">
                  {{ $t("info_card.history_value") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-if="!history || history.length === 0"
                class="grey lighten-4"
              >
                <td class="last-cell text-center" colspan="3">
                  {{ $t("info_card.history_no_item") }}
                </td>
              </tr>
              <tr
                :class="index % 2 === 0 ? 'grey lighten-2' : 'grey lighten-5'"
                v-for="(item, index) in history"
                :key="item.ID"
              >
                <td class="text-center">
                  {{ dateTimeFromDBTranslatorFull(item.created_at) }}
                </td>
                <td class="text-center">
                  {{ objectTranslator(item, "CONSTRAINT_DESCRIPTION") }}
                </td>
                <td class="text-center last-cell">{{ item.VALUE }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import validator from "@/helper/validator";
import ApplicantInfoProvider from "@/services/applicant_info";
import GpaCard from "@/components/info_cards/GPA";
import CreditCard from "@/components/info_cards/Credit";
import {
  objectTranslator,
  inlineTranslator,
  dateTimeFromDBTranslatorFull,
} from "@/helper/translator";

const applicantInfoService = new ApplicantInfoProvider();
export default {
  name: "ApplicantInfoConstriants",
  components: {
    GpaCard,
    CreditCard,
  },
  data: function() {
    return {
      loading: false,

      constaints: null,

      form_validate_status: null,

      checkbox: false,

      terms: [3, 4, 5, 6],
      englishs: [
        {
          englishs_value: "IELTS",
          name_TH: "IELTS",
          name_EN: "IELTS",
        },
        {
          englishs_value: "TOEFL IBT",
          name_TH: "TOEFL IBT",
          name_EN: "TOEFL IBT",
        },
        {
          englishs_value: "TOEFL ITP",
          name_TH: "TOEFL ITP",
          name_EN: "TOEFL ITP",
        },
        {
          englishs_value: "CU-TEP",
          name_TH: "CU-TEP",
          name_EN: "CU-TEP",
        },
        {
          englishs_value: "KMITL-TEP",
          name_TH: "KMITL-TEP",
          name_EN: "KMITL-TEP",
        },
        {
          englishs_value: "Other",
          name_TH: "อื่นๆ (ที่สภาวิชาการกำหนด)",
          name_EN: "Others (designated by the Academic Council)",
        },
        {
          englishs_value: "Graduate in English program",
          name_TH: "สำเร็จหลักสูตรภาษาอังกฤษหรือประกาศที่ใช้ภาษาอังกฤษ",
          name_EN: "Graduate in English Program",
        },
      ],

      Constraint_allGpa: null,
      Constraint_termOfGpa: null,
      Constraint_thaiGpa: null,
      Constraint_thaiCredit: null,
      Constraint_mathGpa: null,
      Constraint_mathCredit: null,
      Constraint_scienceGpa: null,
      Constraint_scienceCredit: null,
      Constraint_physicsGpa: null,
      Constraint_physicsCredit: null,
      Constraint_chemistryGpa: null,
      Constraint_chemistryCredit: null,
      Constraint_bioGpa: null,
      Constraint_bioCredit: null,
      Constraint_scienceMathGpa: null,
      Constraint_scienceMathCredit: null,
      Constraint_englishGpa: null,
      Constraint_englishCredit: null,
      Constraint_foreignGpa: null,
      Constraint_foreignCredit: null,
      Constraint_engExamName: null,
      Constraint_engExamScore: null,

      requiredRules: [validator.required],

      history: [],
    };
  },
  computed: {
    sidebar_status() {
      return this.$store.state.auth.sidebar_status;
    },
    all_clear() {
      if (!this.constaints) return true;
      return this.constaints.reduce(
        (result, item) => result && (!item.required || item.passed),
        true
      );
    },
  },
  watch: {
    constaints() {
      this.history = [];
      this.constaints.map((item) => {
        switch (item.CONSTRAINT_ID) {
          case "":
            this.Constraint_termOfGpa = item.user_value;
            break;
          case "2":
            this.Constraint_allGpa = item.user_value;
            break;
          case "3":
            this.Constraint_thaiGpa = item.user_value;
            break;
          case "4":
            this.Constraint_thaiCredit = item.user_value;
            break;
          case "5":
            this.Constraint_mathGpa = item.user_value;
            break;
          case "6":
            this.Constraint_mathCredit = item.user_value;
            break;
          case "7":
            this.Constraint_scienceGpa = item.user_value;
            break;
          case "8":
            this.Constraint_scienceCredit = item.user_value;
            break;
          case "9":
            this.Constraint_physicsGpa = item.user_value;
            break;
          case "10":
            this.Constraint_physicsCredit = item.user_value;
            break;
          case "11":
            this.Constraint_chemistryGpa = item.user_value;
            break;
          case "12":
            this.Constraint_chemistryCredit = item.user_value;
            break;
          case "13":
            this.Constraint_bioGpa = item.user_value;
            break;
          case "14":
            this.Constraint_bioCredit = item.user_value;
            break;
          case "15":
            this.Constraint_scienceMathGpa = item.user_value;
            break;
          case "16":
            this.Constraint_scienceMathCredit = item.user_value;
            break;
          case "17":
            this.Constraint_englishGpa = item.user_value;
            break;
          case "18":
            this.Constraint_englishCredit = item.user_value;
            break;
          case "21":
            this.Constraint_foreignCredit = item.user_value;
            break;
          case "20":
            this.Constraint_foreignGpa = item.user_value;
            break;
          case "22":
            this.Constraint_engExamName = item.user_value;
            break;
          case "23":
            this.Constraint_engExamScore = item.user_value;
            break;
        }

        item.history.map((item2) => {
          this.history.push(item2);
        });
      });

      this.history = this.history.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      if (this.history.length != 0) this.checkbox = true;
    },
  },
  methods: {
    objectTranslator,
    inlineTranslator,
    dateTimeFromDBTranslatorFull,

    get_constaints_error_text(item) {
      let text = "* ";
      if (item.CONSTRAINT_ID === "2") {
        text += inlineTranslator({
          th: "'GPA รวม (GPAX)' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'GPA (All subjects) (GPAX)' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "3") {
        text += inlineTranslator({
          th: "'GPA วิชาภาษาไทย' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Thai GPA' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "4") {
        text += inlineTranslator({
          th:
            "'หน่วยกิต วิชาภาษาไทย' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Thai Credit' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "5") {
        text += inlineTranslator({
          th: "'GPA วิชาคณิตศาสตร์' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Mathematics GPA' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "6") {
        text += inlineTranslator({
          th:
            "'หน่วยกิต วิชาคณิตศาสตร์' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Mathematics Credit' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "7") {
        text += inlineTranslator({
          th:
            "'GPA วิชาวิทยาศาสตร์' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Science GPA' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "8") {
        text += inlineTranslator({
          th:
            "'หน่วยกิต วิชาวิทยาศาสตร์' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Science Credit' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "9") {
        text += inlineTranslator({
          th: "'GPA วิชาฟิสิกส์' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Physics GPA' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "10") {
        text += inlineTranslator({
          th:
            "'หน่วยกิต วิชาฟิสิกส์' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Physics Credit' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "11") {
        text += inlineTranslator({
          th: "'GPA วิชาเคมี' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Chemistry GPA' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "12") {
        text += inlineTranslator({
          th: "'หน่วยกิต วิชาเคมี' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Chemistry Credit' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "13") {
        text += inlineTranslator({
          th: "'GPA วิชาชีววิทยา' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Biology GPA' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "14") {
        text += inlineTranslator({
          th:
            "'หน่วยกิต วิชาชีววิทยา' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Biology Credit' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "15") {
        text += inlineTranslator({
          th:
            "'GPA วิชาวิทยาศาสตร์ และ คณิตศาสตร์' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Science & Mathematics GPA' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "16") {
        text += inlineTranslator({
          th:
            "'หน่วยกิต วิชาวิทยาศาสตร์ และ คณิตศาสตร์' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Science & Mathematics Credit' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "17") {
        text += inlineTranslator({
          th: "'GPA วิชาภาษาอังกฤษ' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'English GPA' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "18") {
        text += inlineTranslator({
          th:
            "'หน่วยกิต วิชาภาษาอังกฤษ' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'English Credit' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "20") {
        text += inlineTranslator({
          th:
            "'GPA วิชาภาษาต่างประเทศ' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Foreign language GPA' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "21") {
        text += inlineTranslator({
          th:
            "'หน่วยกิต วิชาภาษาต่างประเทศ' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'Foreign language Credit' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "22") {
        text += inlineTranslator({
          th:
            "'มาตรฐานความรู้ภาษาอังกฤษ' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'English Proficiency Test' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "23") {
        text += inlineTranslator({
          th:
            "'มาตรฐานความรู้ภาษาอังกฤษ' ไม่ถึงเกณฑ์ที่ประกาศไว้ หรือ ยังไม่ได้กรอก",
          en:
            "'English Proficiency Test' did not reach the specified criteria or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "24") {
        text += inlineTranslator({
          th:
            "'ข้อมูลเพิ่มเติม (สำหรับนานาชาติ)' ข้อมูลยังไม่สมบูรณ์ หรือ ยังไม่ได้กรอก",
          en: "'International Program Info' did not complete or Not filled in.",
        });
      } else if (item.CONSTRAINT_ID === "25") {
        text += inlineTranslator({
          th:
            "'ข้อมูลเพิ่มเติม (สำหรับคณะแพทย์)' ข้อมูลยังไม่สมบูรณ์ หรือ ยังไม่ได้กรอก",
          en: "'Faculty of Medicine Info' did not complete or Not filled in.",
        });
      }
      return text;
    },

    use_constarint(id) {
      if (!this.constaints) return false;
      const ret = this.constaints.reduce(
        (result, item) =>
          result ||
          (parseInt(item.CONSTRAINT_ID) === parseInt(id) && item.required),
        false
      );
      return ret;
    },

    get_constarint_object(id) {
      if (!this.constaints) return null;
      return this.constaints.filter((item) => item.CONSTRAINT_ID === id)[0];
    },

    async fetch_constraints() {
      this.loading = true;
      await this.$store.dispatch("auth/getSidebarStatus");
      const data = await applicantInfoService.getRegisConstraints();
      this.constaints = data;
      this.loading = false;
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.save();
      }
    },

    async save() {
      this.loading = true;
      let constraintsToSend = [];
      this.constaints.map((item) => {
        switch (item.CONSTRAINT_ID) {
          case "":
            if (this.Constraint_termOfGpa !== null) {
              item.VALUE = this.Constraint_termOfGpa;
              constraintsToSend.push(item);
            }
            break;
          case "2":
            if (this.Constraint_allGpa !== null) {
              item.VALUE = this.Constraint_allGpa;
              constraintsToSend.push(item);
            }
            break;
          case "3":
            if (this.Constraint_thaiGpa !== null) {
              item.VALUE = this.Constraint_thaiGpa;
              constraintsToSend.push(item);
            }
            break;
          case "4":
            if (this.Constraint_thaiCredit !== null) {
              item.VALUE = this.Constraint_thaiCredit;
              constraintsToSend.push(item);
            }
            break;
          case "5":
            if (this.Constraint_mathGpa !== null) {
              item.VALUE = this.Constraint_mathGpa;
              constraintsToSend.push(item);
            }
            break;
          case "6":
            if (this.Constraint_mathCredit !== null) {
              item.VALUE = this.Constraint_mathCredit;
              constraintsToSend.push(item);
            }
            break;
          case "7":
            if (this.Constraint_scienceGpa !== null) {
              item.VALUE = this.Constraint_scienceGpa;
              constraintsToSend.push(item);
            }
            break;
          case "8":
            if (this.Constraint_scienceCredit !== null) {
              item.VALUE = this.Constraint_scienceCredit;
              constraintsToSend.push(item);
            }
            break;
          case "9":
            if (this.Constraint_physicsGpa !== null) {
              item.VALUE = this.Constraint_physicsGpa;
              constraintsToSend.push(item);
            }
            break;
          case "10":
            if (this.Constraint_physicsCredit !== null) {
              item.VALUE = this.Constraint_physicsCredit;
              constraintsToSend.push(item);
            }
            break;
          case "11":
            if (this.Constraint_chemistryGpa !== null) {
              item.VALUE = this.Constraint_chemistryGpa;
              constraintsToSend.push(item);
            }
            break;
          case "12":
            if (this.Constraint_chemistryCredit !== null) {
              item.VALUE = this.Constraint_chemistryCredit;
              constraintsToSend.push(item);
            }
            break;
          case "13":
            if (this.Constraint_bioGpa !== null) {
              item.VALUE = this.Constraint_bioGpa;
              constraintsToSend.push(item);
            }
            break;
          case "14":
            if (this.Constraint_bioCredit !== null) {
              item.VALUE = this.Constraint_bioCredit;
              constraintsToSend.push(item);
            }
            break;
          case "15":
            if (this.Constraint_scienceMathGpa !== null) {
              item.VALUE = this.Constraint_scienceMathGpa;
              constraintsToSend.push(item);
            }
            break;
          case "16":
            if (this.Constraint_scienceMathCredit !== null) {
              item.VALUE = this.Constraint_scienceMathCredit;
              constraintsToSend.push(item);
            }
            break;
          case "17":
            if (this.Constraint_englishGpa !== null) {
              item.VALUE = this.Constraint_englishGpa;
              constraintsToSend.push(item);
            }
            break;
          case "18":
            if (this.Constraint_englishCredit !== null) {
              item.VALUE = this.Constraint_englishCredit;
              constraintsToSend.push(item);
            }
            break;
          case "20":
            if (this.Constraint_foreignGpa !== null) {
              item.VALUE = this.Constraint_foreignGpa;
              constraintsToSend.push(item);
            }
            break;
          case "21":
            if (this.Constraint_foreignCredit !== null) {
              item.VALUE = this.Constraint_foreignCredit;
              constraintsToSend.push(item);
            }
            break;
          case "22":
            if (this.Constraint_engExamName !== null) {
              item.VALUE = this.Constraint_engExamName;
              constraintsToSend.push(item);
            }
            break;
          case "23":
            if (this.Constraint_engExamScore !== null) {
              item.VALUE = this.Constraint_engExamScore;
              constraintsToSend.push(item);
            }
            break;
        }
      });
      const response = await applicantInfoService
        .setRegisConstraints(constraintsToSend)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.save_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.fetch_constraints();
    },
  },
  created() {
    this.fetch_constraints();
  },
};
</script>
<style scoped>
.text1 {
  background-color: orange;
  border: 10px;
  border-radius: 25px;
  color: white;
  padding-left: 3px;
  padding-right: 2px;
}
.text2 {
  background-color: red;
  border: 10px;
  border-radius: 25px;
  color: white;
  padding-left: 3px;
  padding-right: 2px;
}
.constraints_error_box {
  padding: 20px;
  border-radius: 5px;
  border-width: 1;
  border-style: solid;
  border-color: red;
  color: red;
}
</style>
